<template>
  <v-flex xs12>
    <v-flex xs12 mb-3 tag="h3">
      User services:
    </v-flex>
    <v-flex v-for="(service, i) in servicesList" :key="i">
      <v-flex d-inline-flex>
        <v-flex mr-4 mt-3 tag="h4">
          #{{ i + 1 }}
        </v-flex>
        <v-flex>
          <v-btn icon @click="deleteService(service.id)">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn icon @click="editService(service.id, service.description, service.price, service.name)">
            <v-icon icon>save</v-icon>
          </v-btn>
        </v-flex>
        <v-flex>
          <v-text-field v-model="service.name" label="Service name"></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field v-model="service.description" label="Service description"></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            label="Price (only for vendors)"
            type="number"
            v-model="service.price"
            v-if="isVendor"
          ></v-text-field>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex xs12>
      <v-text-field v-model="newServiceDescription" label="Add new service" append-icon="save" :append-icon-cb="saveService"></v-text-field>
    </v-flex>
    <v-flex>
      <v-select
        :items="servicesList"
        item-text="description"
        v-model="selectedService"
        label="Select service to edit checklist"
        v-if="servicesList.length > 0"
      >
        <template slot="item" slot-scope="props">
          {{ props.item.name }} - {{ props.item.description }}
        </template>
        <template slot="selection" slot-scope="props">
          {{ props.item.name }} - {{ props.item.description }}
        </template>
      </v-select>
      <ItemCheckList v-if="selectedService" :item-id="selectedService.id" :item-type="serviceTypeID"></ItemCheckList>
    </v-flex>
  </v-flex>
</template>

<script type="text/javascript">
  import userAPI from '@/api/user'
  import servicesAPI from '@/api/resources/services'
  import ItemCheckList from '@/components/ItemCheckList'
  import itemTypesMixins from '@/mixins/ItemTypes'

  export default {
    components: {
      ItemCheckList
    },
    mixins: [
      itemTypesMixins
    ],
    data () {
      return {
        newServiceDescription: null,
        servicesList: [],
        userData: null,
        selectedService: null
      }
    },
    watch: {
      userId () {
        this.servicesList = []
        this.selectedService = null
        this.newServiceDescription = null
        this.userData = null

        this.loadData()
      }
    },
    methods: {
      loadData () {
        this.loadUser()
        this.loadServices()
      },
      loadUser () {
        userAPI.loadUser(this.userId).then(result => {
          this.userData = result
        }, () => {})
      },
      loadServices () {
        if (this.loadAllServices) {
          servicesAPI.loadServices().then(result => {
            this.servicesList = result
          }, () => {})
        } else {
          userAPI.getLinkedServices(this.userId).then(result => {
            this.servicesList = result
          }, () => {})
        }
      },
      deleteService (serviceId) {
        servicesAPI.delete(serviceId).then(result => {
          this.servicesList = this.servicesList.filter(item => item.id !== serviceId)
        }, () => {})
      },
      editService (serviceId, description, price, name) {
        servicesAPI.edit(serviceId, description, price, name).then(() => {}, () => {})
      },
      saveService () {
        let payload = {
          description: this.newServiceDescription,
          is_available: true,
          name: this.userData.name,
          is_vendor: this.isVendor,
          users_id: this.userId,
          amount: 1
        }

        servicesAPI.add(payload).then(() => {
          this.loadServices()
        }, () => {})
      }
    },
    mounted () {
      this.loadData()
    },
    props: {
      userId: {
        type: Number,
        required: true
      },
      isVendor: {
        type: Boolean,
        required: false,
        default: false
      },
      loadAllServices: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserServices.vue?5e94fdcd